/* eslint-disable react/prop-types */
import React from 'react';

import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import EmojiRatingWithText from './EmojiRatingWithText';
import './style.scss';

class RateManager extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onBack, onNext, showBack, onEmojiRatingClick, propertyManagerRating } = this.props;

    return (
      <div className="RateManager">
        <Center>
          <Text type="body" className="stacked-xs">
            How was your communication with the landlord or manager?
          </Text>
          <Text type="body-small" lowlight className="stacked-md">
            Did they respond in a timely manner and answer your questions?
          </Text>
          <div className="stacked-lg">
            <EmojiRatingWithText rating={propertyManagerRating} onClick={onEmojiRatingClick} />
          </div>
          <div className="RateManager-nav">
            <div>
              {showBack && (
                <Link onClick={onBack} type="secondary">
                  Back
                </Link>
              )}
            </div>
            <div>
              <Button disabled={!propertyManagerRating} onClick={onNext} type="primary">
                Next
              </Button>
            </div>
          </div>
        </Center>
      </div>
    );
  }
}

RateManager.defaultProps = {
  onBack: () => {},
  onNext: () => {},
  propertyManagerRating: null,
  onEmojiRatingClick: () => {},
};

export default RateManager;
